export default {
    
    indexDynamicOffers:         { method: 'get',    url: 'dynamic_offers' },
    createDynamicOffer:         { method: 'post',   url: 'dynamic_offers'},
    updateDynamicOffer:         { method: 'put',    url: 'dynamic_offers/{id}'},
    deleteDynamicOffer:         { method: 'delete', url: 'dynamic_offers/{id}'},
    indexDynamicOfferTypes:     { method: 'get',    url: 'dynamic_offers/types' },
    generateDynamicOffer:       { method: 'put',    url: 'dynamic_offers/{id}/generate' },
}